import { Paper, Stack, Switch, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useDesktopSettings, useSetDesktopConsent } from '@/api/activity';
import { useCurrentWorkspace } from '@/app/WorkspaceContext';
import { useApiError } from '@/hooks/useApiError';

/** Eigene Zustimmung zu Screenshots und App-Erfassung des Desktop-Clients (ACT-04). */
export function DesktopConsentSection() {
  const { t } = useTranslation();
  const ctx = useCurrentWorkspace();
  const allowed = ctx.hasFeature('ACTIVITY') && ctx.hasFeature('SCREENSHOTS');
  const { data } = useDesktopSettings(ctx.workspaceId, allowed);
  const consent = useSetDesktopConsent(ctx.workspaceId);
  const onError = useApiError();
  if (!allowed || !data || (!data.screenshotsEnabled && !data.appTrackingEnabled)) return null;
  const set = (screenshots: boolean, appTracking: boolean) => consent.mutate({ screenshots, appTracking }, { onError });
  return (
    <Paper withBorder p="md">
      <Title order={5} mb="xs">
        {t('activity.desktopConsentTitle')}
      </Title>
      <Text size="sm" c="dimmed" mb="sm">
        {t('activity.desktopConsentText', { days: data.retentionDays })}
      </Text>
      <Stack gap="xs">
        {data.screenshotsEnabled && (
          <Switch
            label={data.blur ? t('activity.consentScreenshotsBlurred') : t('activity.consentScreenshots')}
            checked={data.consentScreenshots}
            disabled={consent.isPending}
            onChange={(e) => set(e.currentTarget.checked, data.consentAppTracking)}
          />
        )}
        {data.appTrackingEnabled && (
          <Switch
            label={t('activity.consentApps')}
            checked={data.consentAppTracking}
            disabled={consent.isPending}
            onChange={(e) => set(data.consentScreenshots, e.currentTarget.checked)}
          />
        )}
      </Stack>
    </Paper>
  );
}
